import Annotation from 'components/Annotation'
import { AnnotationTextMarker as TM } from 'components/Annotation/AnnotationTextMarker'
import { CircleAnnotation } from 'components/Annotation/CircleAnnotation'

const isMobile = window.innerWidth < 712

export const bern_data: CityData = {
  name: 'Berne',
  bfsid: '351',
  sat_images: [
    {
      label: 'Moins aisés - Bümpliz',
      image: isMobile
        ? require('../../../Content/Maps/maps_351_sat_poor_mob.jpg')
        : require('../../../Content/Maps/maps_351_sat_poor.jpg'),
    },
    {
      label: 'Plus aisés - Kirchenfeld',
      image: isMobile
        ? require('../../../Content/Maps/maps_351_sat_rich_mob.jpg')
        : require('../../../Content/Maps/maps_351_sat_rich.jpg'),
    },
  ],
  elements: [
    {
      id: 'all',
      text: (
        <>
          <p>
            A Berne, presque tout le territoire de la ville est exclusivement
            habité par des riches, en particulier près du centre. Les habitants
            les plus pauvres forment quelques taches dans les quartiers de{' '}
            <TM prio={4}>Lorraine, de Breitenrain et de Matte,</TM> ou se
            retrouvent en périphérie de la ville.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 15 : 30}
              angle={isMobile ? 190 : 133}
            >
              Matte
            </CircleAnnotation>
          ),
          position: { x: 72, y: 53 },
          position_mobile: { x: 74, y: 50.5 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 30 : 60}
              angle={isMobile ? 200 : 10}
            >
              Lorraine/Breitenrain
            </CircleAnnotation>
          ),
          position: { x: 67, y: 40 },
          position_mobile: { x: 73, y: 35 },
        },

        {
          content: <Annotation priority={3}>Kirchenfeld</Annotation>,
          position: { x: 68, y: 65 },
          position_mobile: { x: 70, y: 60 },
        },

        {
          content: <Annotation priority={3}>Bümpliz</Annotation>,
          position: { x: 8, y: 68 },
          position_mobile: { x: 10, y: 63 },
        },
        {
          content: <Annotation priority={3}>Bethlehem</Annotation>,
          position: { x: 8, y: 48 },
          position_mobile: { x: 10, y: 45 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_351_all_mob.jpg')
        : require('../../../Content/Maps/maps_351_all.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_351_all_mob_dm.jpg')
        : require('../../../Content/Maps/maps_351_all_dm.jpg'),
    },
    {
      id: 'rich',
      text: (
        <>
          <p>
            Les riches se concentrent au centre-ville et au sud de la capitale.
            Le quartier chic de <TM prio={2}>Kirchenfeld,</TM> par exemple, a
            historiquement été conçu pour accueillir une population aisée.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation size={isMobile ? 35 : 40} angle={75}>
              Kirchenfeld
            </CircleAnnotation>
          ),
          position: { x: 68, y: 61 },
          position_mobile: { x: 74, y: 56 },
        },
        // {
        //   content: <Annotation priority={3}>Matte</Annotation>,
        //   // position: { x: 70, y: 60 },
        //   // position_mobile: { x: 50, y: 50 },
        // },

        {
          content: <Annotation priority={3}>Lorraine/Breitenrain</Annotation>,
          position: { x: 72, y: 41 },
          position_mobile: { x: 60, y: 35 },
        },

        {
          content: <Annotation priority={3}>Bümpliz</Annotation>,
          position: { x: 8, y: 68 },
          position_mobile: { x: 10, y: 63 },
        },
        {
          content: <Annotation priority={3}>Bethlehem</Annotation>,
          position: { x: 8, y: 48 },
          position_mobile: { x: 10, y: 45 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_351_rich_mob.jpg')
        : require('../../../Content/Maps/maps_351_rich.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_351_rich_mob_dm.jpg')
        : require('../../../Content/Maps/maps_351_rich_dm.jpg'),
    },
    {
      id: 'poor',
      text: (
        <>
          <p>
            De nombreux citadins pauvres vivent à <TM prio={3}>Bümpliz</TM>, un
            ancien village de paysans. Les barres d’immeuble sont emblématiques
            du quartier de <TM prio={3}>Bethlehem</TM>.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation size={isMobile ? 45 : 70} angle={45}>
              Bümpliz
            </CircleAnnotation>
          ),
          position: { x: 18, y: 66 },
          position_mobile: { x: 16, y: 59 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 30 : 50}
              angle={isMobile ? 310 : 260}
            >
              Bethlehem
            </CircleAnnotation>
          ),
          position: { x: 18, y: 50 },
          position_mobile: { x: 15, y: 48 },
        },
        // {
        //   content: <Annotation priority={3}>Matte</Annotation>,
        //   position: { x: 70, y: 60 },
        // },
        {
          content: <Annotation priority={3}>Kirchenfeld</Annotation>,
          position: { x: 68, y: 65 },
          position_mobile: { x: 70, y: 60 },
        },
        {
          content: <Annotation priority={3}>Lorraine/Breitenrain</Annotation>,
          position: { x: 72, y: 41 },
          position_mobile: { x: 60, y: 35 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_351_poor_mob.jpg')
        : require('../../../Content/Maps/maps_351_poor.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_351_poor_mob_dm.jpg')
        : require('../../../Content/Maps/maps_351_poor_dm.jpg'),
    },
  ],
}
